"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function Currency(_a) {
    var _b;
    var locale = _a.locale, _c = _a.currency, currency = _c === void 0 ? 'EUR' : _c, display = _a.display, sign = _a.sign, notation = _a.notation, component = _a.component, value = _a.value, children = _a.children, rest = __rest(_a, ["locale", "currency", "display", "sign", "notation", "component", "value", "children"]);
    var number = (_b = value !== null && value !== void 0 ? value : children) !== null && _b !== void 0 ? _b : 0;
    var Component = component !== null && component !== void 0 ? component : 'span';
    return (jsx_runtime_1.jsx(Component, __assign({}, rest, { children: new Intl.NumberFormat(locale, {
            currency: currency,
            currencySign: sign,
            currencyDisplay: display,
            notation: notation,
            style: 'currency',
        }).format(number) }), void 0));
}
exports.default = Currency;
//# sourceMappingURL=Currency.js.map